import React, { useContext, useEffect, useState } from "react";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Truck, Eye, EyeOff, Phone } from "lucide-react";
import "../../../assets/styles/distributor/DistributorLogin.css";
import axios from "axios";
import AppContext from "../../../context/AppContext";
import Swal from "sweetalert2";

const DistributorLogin = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const { baseUrl, storeLoggedInDistributor } = useContext(AppContext);

  useEffect(() => {
    const distributorPhone    = localStorage.getItem("distributorPhone");
    const distributorPassword = localStorage.getItem("distributorPassword");
    if (distributorPhone != null && distributorPassword != null) {
      autoLogin(distributorPhone, distributorPassword);
    }
  }, []);

  const autoLogin = (distributorPhone, distributorPassword) => {
    const formData = new FormData();
    formData.append("phonenumber", distributorPhone);
    formData.append("password",    distributorPassword);

    axios
      .post(`${baseUrl}/distributor/auth/loginDistributor`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        if (response.data.success === true) {
          const distributor = response.data.distributor;
          localStorage.setItem("distributorId", distributor.id);
          localStorage.setItem("loggedInDistributor", JSON.stringify(distributor));
          storeLoggedInDistributor(distributor);
          navigate("/distributor/dashboard");
        }
      })
      .catch((error) => console.log(error));
  };

  const distributorLogin = () => {
    const formData = new FormData();
    formData.append("phonenumber", phone);
    formData.append("password",    password);

    axios
      .post(`${baseUrl}/distributor/auth/loginDistributor`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        if (response.data.success === true) {
          const distributor = response.data.distributor;

          // ✅ sahi tarike se store karo
          localStorage.setItem("distributorId",       distributor.id);
          localStorage.setItem("distributorPhone",    phone);
          localStorage.setItem("distributorPassword", password);
          localStorage.setItem("loggedInDistributor", JSON.stringify(distributor));

          storeLoggedInDistributor(distributor);

          Swal.fire({
            title: "Welcome Back!",
            text:  "Hello! How are you today!",
            icon:  "success",
            confirmButtonText: "Close",
          });

          navigate("/distributor/dashboard");
        }
      })
      .catch((error) => console.log(error));
  };

  return (
    <div className="distributor-login-page">
      <Container fluid="sm">
        <Row className="justify-content-center">
          <Col xs={12} sm={10} md={8} lg={5} xl={4}>
            <div className="distributor-login-card">
              <div className="distributor-login-icon">
                <Truck size={32} strokeWidth={1.8} />
              </div>
              <div className="distributor-login-header">
                <h2>Distributor Login</h2>
                <p>Manage your customers & daily deliveries</p>
              </div>
              <Form>
                <Form.Group className="distributor-login-field">
                  <Form.Label>Phone Number</Form.Label>
                  <div className="distributor-login-input-wrap">
                    <Phone className="distributor-login-input-icon" size={16} />
                    <Form.Control
                      type="tel"
                      placeholder="03XX-XXXXXXX"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      className="distributor-login-input has-icon"
                      required
                    />
                  </div>
                </Form.Group>
                <Form.Group className="distributor-login-field">
                  <Form.Label>Password</Form.Label>
                  <div className="distributor-login-input-wrap">
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      placeholder="········"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="distributor-login-input"
                      required
                    />
                    <button
                      type="button"
                      className="distributor-login-pw-toggle"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                    </button>
                  </div>
                </Form.Group>
                <Button
                  type="button"
                  className="distributor-login-btn"
                  onClick={distributorLogin}
                >
                  Login In
                </Button>
              </Form>
              <div className="distributor-login-footer">
                Don't have an account?{" "}
                <button
                  className="distributor-login-link"
                  onClick={() => navigate("/distributor-signup")}
                >
                  Become a Distributor
                </button>
              </div>
            </div>
          </Col>
        </Row>
        </Container>
    </div>
  );
};

export default DistributorLogin;